class StringHelpers {
    constructor() {
    }

    isEmpty(string) {
        return (
            string === null ||
                string === "" ||
                typeof string === "undefined"
        );
    }

    hasValue(string) {
        return !this.isEmpty(string);
    }
}


export default StringHelpers;